interface Props {
  value: string;
  onChange: (v: string) => void;
  options?: string[];
  // Произвольный диапазон. Если value === 'custom' — компонент рендерит
  // два <input type="date">. customStart/customEnd должны быть ISO
  // (YYYY-MM-DD) либо null. onCustomChange зовётся при изменении любой
  // из границ.
  customStart?: string | null;
  customEnd?: string | null;
  onCustomChange?: (start: string | null, end: string | null) => void;
}

const LABELS: Record<string, string> = {
  today: "Сегодня",
  yesterday: "Вчера",
  this_week: "Эта неделя",
  last_week: "Прошлая неделя",
  this_month: "Этот месяц",
  last_month: "Прошлый месяц",
  this_quarter: "Этот квартал",
  custom: "Произвольный диапазон…",
};

const ALL_KEYS = [
  "today", "yesterday",
  "this_week", "last_week",
  "this_month", "last_month",
  "this_quarter", "custom",
];

export function PeriodPicker({
  value, onChange, options,
  customStart, customEnd, onCustomChange,
}: Props) {
  const opts = options ?? ALL_KEYS;
  return (
    <div className="space-y-2">
      <select
        className="w-full px-3 py-2 rounded-lg bg-tg-secondaryBg text-tg-text border border-transparent focus:outline-none"
        value={value}
        onChange={(e) => onChange(e.target.value)}
      >
        {opts.map((k) => (
          <option key={k} value={k}>
            {LABELS[k] || k}
          </option>
        ))}
      </select>
      {value === "custom" && (
        <div className="grid grid-cols-2 gap-2">
          <input
            type="date"
            value={customStart || ""}
            onChange={(e) =>
              onCustomChange?.(e.target.value || null, customEnd ?? null)
            }
            className="px-2 py-1.5 rounded-lg bg-tg-secondaryBg text-tg-text text-sm"
          />
          <input
            type="date"
            value={customEnd || ""}
            onChange={(e) =>
              onCustomChange?.(customStart ?? null, e.target.value || null)
            }
            className="px-2 py-1.5 rounded-lg bg-tg-secondaryBg text-tg-text text-sm"
          />
        </div>
      )}
    </div>
  );
}
